const caseHeaderValidations = (values: any, claimNumberLabel: any) => {
    const errors: any = {};
    
    if (!values.priorityid) {
        errors.priorityid = "Please select Priority.";
    }

    if (!values.casereviewtypeid) {
      errors.casereviewtypeid = "Please select Case (Review) Type.";
    }
    if (!values.claimnumber) {
        errors.claimnumber = "Claim Number is mandatory.";
    }
    if (claimNumberLabel == "SIBTF Case Number" && !values.casenumber) {
        errors.casenumber = "SIBTF Case Number is mandatory.";
    }
   
    return errors;
  };
  
  export default caseHeaderValidations;
  